const messages = {
  pt: {
    translations: {
      aiOperational: {
        blockedReply: "Continuo por aqui para ajudar com o seu atendimento.",
        blockedAudit: "Ação da IA não executada pelas regras do atendimento",
        summaryMissingTime: "Informe os prazos para conferir a sequência de encerramento.",
        summaryNoInactivity: "Encerramento por falta de resposta desativado.",
        summaryNoFollowUp: "Acompanhamento desativado.",
        summaryFollowUp: "Acompanhamento após {{minutes}} minuto(s) sem resposta.",
        summaryCommunication: "Mensagem ao encerrar: {{mode}}.",
        summaryResolution: "Encerramento por conclusão: {{mode}}.",
        summaryNoTransfer: "Transferências desativadas.",
        summaryTransfer: "Transferências permitidas para {{count}} destino(s).",
        summaryTitle: "Confira antes de salvar",
        followUpInstructionHelp: "Descreva como retomar a conversa. Este é o único campo de acompanhamento no modo atual.",
        minutesHelp: "Informe um número inteiro maior que zero.",
        inactivityMinutes: "Aguardar antes de encerrar (minutos)",
        followUpMinutes: "Aguardar antes do acompanhamento (minutos)",
        resolutionHelp: "Escolha quando o agente pode reconhecer a conclusão. Falha técnica ou solicitação ainda pendente não são atendimento concluído.",
        confirmationHelp_not_required: "O agente pode decidir transferir sem pedir confirmação, respeitando os destinos e as regras configuradas.",
        confirmationHelp_always: "Mesmo quando o contato pedir diretamente, o agente deve solicitar confirmação antes de transferir.",
        confirmationHelp_direct_request_or_acceptance: "Se o contato pedir diretamente, o agente pode transferir. Se o agente sugerir, precisa aguardar o aceite.",
        noDestinations: "Nenhum destino encontrado.",
        aiNotAllowed: "Este setor não permite agentes de IA.",
        agentNotReady: "O agente de destino ainda não está ativo e pronto para receber transferências.",
        unavailableDestination: "Destino indisponível na configuração atual.",
        selfDestination: "O agente não pode transferir para si mesmo.",
        savedUnavailable: "Destino salvo indisponível",
        missingDestinations: "Há {{count}} destino(s) salvo(s) fora da lista atual. Eles foram preservados; revise a configuração antes de salvar.",
        selectGroup: "Selecionar este setor",
        clearEligible: "Desmarcar os disponíveis",
        selectAll: "Selecionar todos os disponíveis",
        selectedCount: "Destinos selecionados: {{count}}",
        searchDestinations: "Buscar setor ou pessoa",
        followUpTitle: "Acompanhamento e fechamento",
        transferTitle: "Transferências",
        unsupportedPolicy: "A configuração salva usa um formato não reconhecido. Seus dados foram preservados. Solicite revisão antes de alterar o modo.",
        legacyMode: "Este agente usa o modo anterior. As opções de proatividade e fechamento desse modo continuam disponíveis abaixo. Ativar as novas regras muda o modo de atendimento ao salvar.",
        currentMode: "Estas opções controlam transferência, acompanhamento e fechamento. Os valores do modo anterior continuam salvos.",
        loading: "Carregando disponibilidade e destinos...",
        transferInstruction: "Orientação curta sobre quando transferir",
        followUpPreview: "Resposta enviada → aguarda {{followUp}} min → envia acompanhamento → aguarda mais {{close}} min → encerra se não houver resposta e o atendimento estiver apto ao encerramento.",
        directPreview: "Resposta enviada → aguarda {{close}} min → encerra se não houver resposta e o atendimento estiver apto ao encerramento.",
  "title": "Regras de atendimento",
  "help": "Configure o que o agente pode fazer. Permissões e prazos ficam nestas opções; use as instruções para orientar a conversa.",
  "ready": "Regras disponíveis neste ambiente.",
  "pending": "Estas regras ainda não estão liberadas neste ambiente. Você pode preparar a configuração, mas ela só será usada após a liberação.",
  "catalogFailed": "Não foi possível carregar os destinos. Reabra o cadastro antes de configurar transferências.",
  "enable": "Usar regras de transferência e fechamento",
  "transfer": "Permitir transferência",
  "destinationsHelp": "Escolha setores ou pessoas para receber transferências. Uma pessoa pode aparecer em mais de um setor. Esta seleção não altera os setores onde este agente atende.",
  "defaultDestination": "Destino para pedido sem setor",
  "askDestination": "Perguntar qual destino",
  "confirmation": "Quando pedir confirmação para transferir",
  "directOrAccept": "Quando sugerir a transferência",
  "always": "Sempre pedir confirmação",
  "notRequired": "Permitir transferência sem confirmação",
  "continuity": "Ao transferir para outro agente de IA, o pedido e os documentos relacionados seguem com o atendimento.",
  "resolution": "Quando encerrar um atendimento concluído",
  "off": "Desativado",
  "activeOnly": "Quando o contato responder ao acompanhamento",
  "clearResolution": "Quando identificar que o atendimento foi concluído",
  "followUp": "Enviar acompanhamento quando o contato parar de responder",
  "inactivity": "Encerrar se o contato continuar sem responder",
  "minutes": "Prazo em minutos — obrigatório e maior que zero",
  "followUpAnchor": "No contrato V2, a resposta da IA ou o envio confirmado pela API inicia o primeiro prazo. Depois do acompanhamento, começa o prazo de encerramento. Se a IA optar pelo silêncio sem pendências ou o canal impedir o acompanhamento, o prazo de inatividade continua sem novo acompanhamento.",
  "directAnchor": "Sem acompanhamento, o prazo de encerramento começa após o envio confirmado. No contrato V2, o silêncio da IA também inicia esse prazo quando não há oferta ou trabalho da equipe pendente. Fora da janela do WhatsApp Oficial, o encerramento é silencioso.",
  "cancelHelp": "Se o contato responder ou alguém assumir, transferir ou reabrir o atendimento, o prazo anterior é cancelado. Falhas de envio não iniciam o prazo. Alterar estas regras também cancela os prazos anteriores.",
  "followUpInstruction": "Orientação curta para o acompanhamento",
  "communication": "Comunicação ao encerrar",
  "silent": "Sem mensagem adicional",
  "farewell": "Uma despedida configurada",
  "farewellText": "Texto da despedida",
  "validation": "Para validar, use atendimentos de teste separados: pedido direto, oferta aceita e recusada, resposta ambígua, resolução clara e solicitação ainda pendente. Confira fila, responsável, status e histórico; a frase do agente não comprova execução."
},
      myProfile: {
        title: "Meu perfil", description: "Atualize seus dados pessoais e preferências. Permissões, filas e horários são administrados pela organização.", changePhoto: "Alterar foto", photoHelp: "PNG, JPG ou WebP.", name: "Nome", email: "E-mail", password: "Nova senha", passwordHelp: "A senha atual não é exibida. Deixe em branco para mantê-la ou digite uma nova senha.", language: "Idioma", ticketOrder: "Ordem dos atendimentos", oldestFirst: "Mais antigos primeiro", newestFirst: "Mais recentes primeiro", save: "Salvar alterações", saving: "Salvando...", success: "Perfil atualizado com sucesso."
      },
      organization: {
        title: "Organização", description: "Identidade, dados institucionais e preferências gerais do tenant.", guidance: "Estas informações pertencem à sua empresa e são isoladas dos demais tenants. Somente administradores podem alterá-las.", logo: "Logotipo claro", logoDark: "Logotipo escuro", logoHelp: "PNG, JPG ou WebP; máximo de 2 MB.", name: "Nome da empresa", businessName: "Razão social", document: "CNPJ ou documento", phone: "Telefone", email: "E-mail institucional", website: "Site", address: "Endereço", timezone: "Fuso horário", defaultLanguage: "Idioma padrão", primaryColor: "Cor principal", tenantId: "Código do tenant", save: "Salvar organização", saving: "Salvando...", success: "Dados da organização atualizados."
      },
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          companyName: "Empresa",
          name: "Nome",
          email: "Email",
          password: "Senha",
          language: "Idioma",
          languageOptions: {
            pt: "Português (Brasil)",
            en: "English",
            es: "Español"
          }
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Atendimentos hoje: ",
          },
        },
        messages: {
          inAttendance: {
            title: "Em Atendimento"
          },
          waiting: {
            title: "Aguardando"
          },
          closed: {
            title: "Finalizado"
          }
        },
        indicators: {
          title: "Indicadores",
          filters: {
            period: "Período",
            start: "Início",
            end: "Fim",
            queue: "Fila",
            connection: "Conexão",
            allQueues: "Todas as minhas filas",
            allConnections: "Todas as conexões",
            nowNote: "Agora mostra a situação atual. Use Fila e Conexão para recortar este retrato.",
            periodNote: "Período, Fila e Conexão filtram os indicadores desta aba.",
          },
          periods: {
            today: "Hoje",
            yesterday: "Ontem",
            thisWeek: "Essa semana",
            lastWeek: "Semana passada",
            thisMonth: "Este mês",
            lastMonth: "Mês passado",
            custom: "Outro período",
          },
          tabs: {
            now: "Agora",
            period: "Período",
            agents: "Atendentes",
            queues: "Filas",
            connections: "Conexões",
            lists: "Listas",
          },
          periodMetrics: {
            started: "Entradas",
            reopened: "Reabertos",
            closed: "Fechados",
            reopenRate: "Taxa de reabertura",
            firstResponse: "Primeira resposta média",
            resolution: "Resolução média",
            inbound: "Mensagens recebidas",
            outbound: "Mensagens enviadas",
            closedByHour: "Fechados por hora",
          },
          global: {
            health: "Temperatura da Operação",
            waitingForService: "Aguardando Atendimento",
            inService: "Em Atendimento",
            unanswered: "Atendimento sem Resposta",
            averageWait: "Tempo Medio de Espera",
            longestWait: "Maior Espera",
            busiestAgent: "Com mais Atendimentos em Atendendo",
            busiestArea: "Com mais Atendimentos em Aguardando",
            healthDescription: "Saúde geral do atendimento agora, sem depender dos filtros abaixo.",
            scale: {
              excellent: "Excelente",
              good: "Boa",
              warning: "Atenção",
              critical: "Crítica",
              emergency: "Emergencial",
            },
          },
          help: {
            tooltip: "Ajuda do indicador",
            compositionTitle: "O que entra na conta",
            improveTitle: "Como melhorar",
            close: "Fechar",
            backlog: {
              title: "Backlog ativo",
              description: "Quantidade de tickets abertos + pendentes dentro do escopo das filas que você pode acessar.",
              insight: "Reduza o backlog com triagem rápida, distribuição por fila e automações para perguntas recorrentes.",
            },
            waiting: {
              title: "% em espera",
              description: "Percentual de pendentes sobre aberto + pendente. Quanto maior, maior o gargalo de triagem.",
              insight: "Defina alertas quando passar do limite e puxe atendimentos para evitar envelhecimento da fila.",
            },
            unread: {
              title: "Não lidos totais",
              description: "Conversas com mensagens ainda não lidas no seu escopo.",
              insight: "Priorize não lidos antigos e use alerta por tempo sem leitura.",
            },
            ratio: {
              title: "Relação atendimento vs fila",
              description: "Compara tickets abertos com pendentes. Maior que 1 indica time puxando fila.",
              insight: "Mantenha acima de 1 em horário de pico com ajuste de escala e roteamento.",
            },
            flow: {
              title: "Fluxo por hora",
              description: "Distribuição por hora baseada no volume do período dentro do filtro aplicado.",
              insight: "Use os horários de pico para reforçar equipe e automações preventivas.",
            },
            age: {
              title: "Idade dos tickets",
              description: "Faixas por tempo sem evolução para aberto e pendente.",
              insight: "Tickets acima de 60 minutos devem entrar em fila de prioridade.",
            },
            queue: {
              title: "Tickets por fila",
              description: "Top filas no período filtrado.",
              insight: "Rebalanceie equipe quando uma fila concentrar muito volume.",
            },
            agentAvg: {
              title: "Tempo médio por atendente",
              description: "Média entre abertura e última atualização dos tickets fechados por atendente no período filtrado.",
              insight: "Compare com volume atendido para identificar gargalos e apoiar o time com maior fila média.",
            },
            channel: {
              title: "Tickets por conexão",
              description: "Distribuição por conexão no período filtrado.",
              insight: "Direcione automações para conexões com maior entrada.",
            },
            group: {
              title: "Grupos vs Individuais",
              description: "Compara tickets de grupos com conversas individuais.",
              insight: "Se grupos crescerem, aplique regras e donos fixos para reduzir ruído.",
            },
          },
          sections: {
            flow: "Fluxo por hora",
            closed: "Fechados: {{count}}",
            ageRanges: "Faixas de idade",
            ticketsByQueue: "Tickets por fila (Top 10)",
            ticketsByConnection: "Tickets por conexão",
            groupsVsIndividuals: "Grupos vs Individuais",
            agentAverage: "Tempo médio de atendimento por atendente (Top 10)",
            operationalInsights: "Insights operacionais",
            currentSample: "Amostra no filtro atual: {{count}} tickets",
            agents: "Desempenho por atendente",
            queues: "Desempenho por fila",
            connections: "Desempenho por conexão",
          },
          empty: {
            movement: "Sem movimentação no período. Amplie o período ou selecione outra conexão.",
            age: "Sem tickets ativos no período para calcular faixa de idade.",
            queue: "Sem volume por fila no período selecionado.",
            connection: "Sem volume por conexão no período selecionado.",
            group: "Sem tickets suficientes para comparar grupos e individuais.",
            agentAverage: "Sem tickets fechados com atendente no período selecionado.",
            noData: "Sem dados para o filtro selecionado.",
          },
          rank: {
            active: "ativos",
            closed: "fechados",
            sent: "enviadas",
            waiting: "aguardando",
            inService: "atendendo",
            started: "entradas",
            inbound: "recebidas",
          },
          table: {
            agent: "Atendente",
            agentType: "Tipo de atendente",
            queue: "Fila",
            connection: "Conexão",
            channel: "Canal",
            active: "Em aberto",
            waiting: "Aguardando",
            inService: "Em atendimento",
            started: "Entradas",
            closed: "Fechados",
            closedPercentage: "Percentual de fechados",
            sent: "Mensagens enviadas",
            inbound: "Recebidas",
            avgWait: "Espera média",
            avgResolution: "Tempo de resolução",
          },
          attendantType: {
            human: "Humano",
            aiAgent: "Agente de I.A.",
            unassigned: "Sem atendente",
          },
          actionLists: {
            waitingLongest: "Aguardando há mais tempo",
            unanswered: "Sem resposta do agente",
            slaRisk: "Risco de SLA",
            reopened: "Reabertos no período",
          },
          fallback: {
            connection: "Conexão {{id}}",
            noQueue: "Sem fila",
            noConnection: "Sem conexão",
            noAgent: "Sem atendente",
            noDefinedQueue: "Sem fila definida",
            groups: "Grupos",
            individuals: "Individuais",
          },
          chart: {
            entries: "Entradas",
          },
          insights: {
            noBacklog: "Sem backlog ativo no escopo atual. Aproveite para revisar macros e regras de triagem para os próximos picos.",
            highWaiting: "Fila sob pressão: {{pendingCount}} pendentes ({{waitingPercent}}%). Realoque atendentes para filas com maior volume imédiatamente.",
            mediumWaiting: "Atenção em espera: {{waitingPercent}}% dos tickets estão pendentes. Defina mutirão curto para reduzir pendência abaixo de 25%.",
            oldestPending: "Existe ticket pendente há {{minutes}} min. Priorize os mais antigos para proteger SLA.",
            unread: "Há {{count}} conversas não lidas. Ordene por mais antigas e faça limpeza em lotes de 10.",
            topQueue: "A fila {{name}} concentra {{share}}% do volume. Avalie redistribuição de equipe ou automação dedicada.",
            topConnection: "A conexão {{name}} representa {{share}}% da demanda. Vale revisar capacidade e templates dessa conexão.",
            stable: "Operação estável no filtro atual. Mantenha monitoramento por hora e ajuste fino por fila quando houver pico.",
          },
        }
      },
      connections: {
        title: "Conexões",
        toasts: {
          deleted: "Conexão com o WhatsApp excluída com sucesso!",
          restarting: "Reiniciando a conexão. Aguarde alguns instantes.",
          paused: "Conexão pausada. Use Reiniciar conexão para voltar sem ler QR Code.",
          disconnected: "Conexão desconectada. Para voltar, gere e leia um novo QR Code.",
          openTicketsHistorySynced:
            "Histórico sincronizado em {{tickets}} atendimentos abertos. {{messages}} mensagens novas importadas. Falhas: {{failures}}.",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar WhatsApp",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          restart: "Reiniciar conexão",
          connecting: "Conectando",
          sessionActions: "Ações da sessão",
        },
        sessionMenu: {
          viewQr: "Ver QR Code atual",
          viewQrHelp: "Exibe o QR Code quando a conexão está aguardando leitura.",
          restart: "Reiniciar sem novo QR",
          restartHelp: "Fecha e abre a sessão local mantendo a autenticação do celular.",
          pause: "Pausar conexão",
          pauseHelp: "Para a sessão local sem sair do WhatsApp no celular.",
          syncOpenTicketsHistory: "Sincronizar atendimentos abertos",
          syncOpenTicketsHistoryHelp:
            "Busca mensagens recentes do WhatsApp para tickets abertos desta conexão.",
          newQr: "Solicitar novo QR Code",
          newQrHelp: "Limpa a sessão local e gera um novo QR Code para leitura.",
          disconnect: "Desconectar do celular",
          disconnectHelp: "Sai do WhatsApp Web. Para voltar, será necessário ler um novo QR Code.",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente reiniciar a conexão. Solicite um novo QR Code somente se a sessão não voltar.",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto. Use Reiniciar conexão antes de solicitar um novo QR Code.",
          },
        },
        table: {
          id: "ID",
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
      },
      connectionSetup: {
        back: "Voltar",
        cancel: "Cancelar",
        close: "Fechar",
        save: "Salvar",
        saving: "Salvando...",
        retry: "Retestar",
        connectWithMeta: "Conectar com Meta",
        connecting: "Conectando...",
        waitingMeta: "Aguardando Meta...",
        configureManually: "Configurar manualmente",
        officialApi: "API Oficial",
        qrCode: "QR Code",
        noDefaultQueue: "Sem fila padrão",
        selectQueue: "Selecione uma fila",
        defaultConnection: "Marcar como padrão",
        makeDefaultConnection: "Tornar conexão padrão",
        connectionName: "Nome da conexão",
        queueForNewContacts: "Fila para novos contatos",
        outboundQueues: "Filas autorizadas para atendimentos ativos",
        outboundQueuesHelp: "Selecione as filas que podem usar esta conexão ao iniciar manualmente um atendimento.",
        userForNewContacts: "Usuario para novos contatos",
        userForNewContactsHelp: "Opcional. Selecione um humano ou agente de IA para assumir automaticamente os novos atendimentos desta conexao.",
        selectUser: "Selecione um usuário",
        webhookUrl: "Webhook URL",
        webchat: {
          customizationSaveHelp: "Ajuste a aparencia e clique em Salvar personalizacao para aplicar nesta conexao. O snippet publicado continua o mesmo e nao expira; so sera necessario substitui-lo se a conexao for recriada ou a chave publica for rotacionada por seguranca.",
          saveCustomization: "Salvar personalizacao",
          customizationSaved: "Personalizacao do Webchat salva com sucesso.",
          prechatTitle: "Campos antes do chat",
          prechatHelp: "Escolha quais dados o visitante deve informar antes de conversar. Se todos ficarem desligados, o chat abre direto na conversa.",
          askName: "Pedir nome",
          askEmail: "Pedir e-mail",
          askWhatsapp: "Pedir WhatsApp",
          showFrame: "Exibir moldura no Embed Line",
          showFrameHelp: "Desative para incorporar o chat ao layout do site. Antes da primeira mensagem, apenas o compositor compacto aparece; depois do envio, a conversa se expande automaticamente.",
        },
        facebook: {
          titleAdd: "Nova Conexão Facebook Messenger",
          titleEdit: "Editar Facebook Messenger",
          autoDescription: "Entre com a conta Meta administradora da Página, autorize o app Flowch e escolha qual Página recebera mensagens no Flowch Talk. O token da Página, webhook e assinatura sao tratados automaticamente pelo backend.",
          manualDescription: "Use apenas quando suporte ou implantação técnica precisar informar Page ID, Page Access Token e Verify Token diretamente.",
          manualIntro: "Use esta conexão para receber mensagens da Página do Facebook via Messenger. O contato precisa iniciar a conversa pela Página; depois disso o Flowch Talk pode responder dentro da janela permitida pela Meta.",
          pageIdHelp: "ID da Página do Facebook que recebera as mensagens.",
          pageAccessTokenEdit: "Page Access Token (opcional para manter o atual)",
          pageAccessTokenHelp: "Token da Página com permissão para enviar mensagens pelo Messenger.",
          verifyTokenHelp: "Crie uma palavra-chave segura e use exatamente o mesmo valor na configuração do webhook da Meta.",
          queueHelp: "Mensagens recebidas pela Página entram nesta fila.",
          webhookTitle: "Configurar webhook na Meta",
          webhookInstructions: "1. Salve esta conexão. 2. No app da Meta, configure o webhook do Messenger usando a URL abaixo. 3. Informe o mesmo Verify Token cadastrado aqui. 4. Assine os eventos de mensagens da Página e envie uma mensagem de teste pelo Messenger.",
          autoIntro: "Informe uma identificação interna e a fila padrão. Depois clique em Conectar com Meta. O cliente deve entrar com uma conta que administra a Página, aceitar as permissoes solicitadas e selecionar a Página que sera conectada. Ao concluir, o Flowch Talk salva as credenciais com segurança, assina o webhook e executa o diagnóstico automaticamente.",
          nameAutoHelp: "Se deixar em branco, o Flowch cria um nome automaticamente.",
          choosePageTitle: "Escolha a Página do Facebook",
          choosePageHelp: "A conexão sera criada com a Página selecionada. Depois disso, ela continua disponível para editar nome, fila, padrão e credenciais em modo manual quando suporte precisar.",
          pageLabel: "Página",
          complete: "Concluir conexão",
          subscribeWebhook: "Assinar webhook da Página",
          validationRequired: "Informe nome, Page ID, Verify Token e Token da Página.",
          updated: "Conexão Facebook Messenger atualizada com sucesso.",
          created: "Conexão Facebook Messenger criada com sucesso.",
          metaStartFailed: "Não foi possível iniciar o fluxo da Meta.",
          popupBlocked: "Seu navegador bloqueou o popup da Meta. Libere popups e tente novamente.",
          finishLogin: "Finalize o login da Meta na janela aberta para listar suas Páginas.",
          selectPage: "Selecione uma Página do Facebook para concluir.",
          pageNotFound: "Página selecionada não encontrada.",
          diagnosisPending: "Conexão criada, mas o diagnóstico encontrou pendências.",
          loginCompleted: "Login Meta concluido. Selecione a Página para conectar.",
          webhookSubscribed: "Assinatura do webhook solicitada com sucesso.",
        },
        whatsappOfficial: {
          titleAdd: "Nova Conexão WhatsApp Oficial (API)",
          titleEdit: "Editar WhatsApp Oficial (API)",
          autoDescription: "Entre com a conta Meta administradora da empresa, selecione o WABA e o número do WhatsApp. O Flowch Talk salva as credenciais, configura o webhook e executa o diagnóstico automaticamente.",
          manualDescription: "Use quando suporte ou implantação técnica precisar informar API Oficial por campos técnicos ou conectar por QR Code.",
          officialApiDescription: "Use os dados da sua conta Meta, como WABA ID, Phone Number ID, token e verify token.",
          qrCodeDescription: "Conecte manualmente uma conta pelo pareamento do WhatsApp Web quando a API Oficial não for a melhor opção.",
          manualIntro: "Informe WABA ID, Phone Number ID, Access Token e Verify Token da WhatsApp Business Platform. Depois salve e teste a conexão para validar token, número, WABA e webhook.",
          metaIntro: "Clique em Conectar com Meta, autorize as permissoes solicitadas e escolha a empresa/número do WhatsApp. Ao concluir, o Flowch Talk busca WABA ID, Phone Number ID e token, assina o webhook da Meta e mostra o diagnóstico final.",
          cloudApiModeTitle: "Novo número / API",
          cloudApiModeDescription: "Conecte um número novo ou já preparado exclusivamente para a API Oficial da Meta.",
          coexistenceModeTitle: "Continuar usando meu WhatsApp Business",
          coexistenceModeDescription: "Mantenha o mesmo número no aplicativo WhatsApp Business e também atenda pelo Flowch Talk.",
          coexistenceIntro: "Clique em Conectar com Meta e escolha o número que já está ativo no aplicativo WhatsApp Business. O Flowch confirma a coexistência, importa o histórico autorizado e acompanha mensagens enviadas pelo celular sem acionar a IA.",
          coexistenceEligibilityHelp: "Requisitos da Meta: aplicativo WhatsApp Business atualizado, número elegível e configuração de coexistência liberada para o app Flowch. A opção não desconecta o celular automaticamente.",
          coexistenceConfigurationPending: "Indisponível neste ambiente até concluir a configuração do aplicativo na Meta.",
          coexistenceUnavailable: "A coexistência ainda não está configurada neste ambiente. Use Novo número / API ou peça a ativação ao suporte.",
          coexistenceBadge: "Coexistência",
          metaApplicationLabel: "Aplicativo Meta",
          metaApplicationHelp: "Use o aplicativo Flowch configurado no ambiente ou selecione um aplicativo próprio da empresa. A assinatura do webhook e o Embedded Signup usarão somente as credenciais escolhidas aqui.",
          metaApplicationFlowchDefault: "Aplicativo Flowch padrão do ambiente",
          metaApplicationOwnerFlowch: "Flowch",
          metaApplicationOwnerCompany: "Aplicativo próprio",
          metaApplicationAdd: "Cadastrar aplicativo próprio",
          metaApplicationEdit: "Editar aplicativo",
          metaApplicationAddTitle: "Cadastrar aplicativo Meta da empresa",
          metaApplicationEditTitle: "Editar aplicativo Meta da empresa",
          metaApplicationInstructions: "No Meta for Developers, copie App ID e App Secret. Defina um Verify Token para usar no webhook. Config IDs são necessários apenas para Embedded Signup/coexistência. Após salvar, use a URL exibida e assine messages. Segredos ficam criptografados e não são devolvidos.",
          metaApplicationName: "Nome interno do aplicativo",
          metaApplicationSecretHelp: "O App Secret é armazenado criptografado e nunca será exibido novamente.",
          metaApplicationVerifyTokenEditHelp: "Deixe vazio para preservar o Verify Token atual. Para substituí-lo, informe pelo menos 16 caracteres e atualize o mesmo valor no webhook da Meta; isso pode interromper a verificação até concluir os dois lados.",
          metaApplicationVerifyTokenRequired: "Defina um Verify Token com pelo menos 16 caracteres para o novo aplicativo. Na edição, deixe vazio para preservar o valor existente.",
          metaApplicationConfigHelp: "Necessário somente para Conectar com Meta (Embedded Signup). O cadastro manual não exige Config ID.",
          metaApplicationWebhookChecklist: "Na Meta, use esta URL de callback e o Verify Token definido no aplicativo; assine messages. Depois confira o diagnóstico. Salvar configuração não comprova envio ou recebimento.",
          setupQueueMissing: "Nenhuma fila disponível. Feche este cadastro, crie uma fila em Filas e retorne a Conexões. Uma fila de destino é obrigatória.",
          manualVerifyTokenHelp: "Informe o Verify Token definido para o aplicativo escolhido. No modo padrão do ambiente, use o token da configuração correspondente. Não use o Access Token neste campo.",
          manualSaveEffects: "Salvar pode configurar o webhook e inscrever o aplicativo na conta WhatsApp usando as credenciais escolhidas. Salvar e testar cria a conexão antes de consultar a Meta. Nenhuma dessas ações envia uma mensagem de teste.",
          testConnection: "Testar conexão",
          saveAndTestConnection: "Salvar e testar conexão",
          metaApplicationVerifyTokenHelp: "Defina um Verify Token com pelo menos 16 caracteres e guarde-o em local seguro para informar no campo Verificar token da Meta. Ele não é o Access Token. O valor salvo não será exibido novamente.",
          metaApplicationSave: "Salvar aplicativo",
          metaApplicationDelete: "Excluir aplicativo",
          metaApplicationDeleteConfirm: "Excluir este aplicativo Meta? A exclusão só será permitida se nenhuma conexão estiver vinculada.",
          metaApplicationWebhookHelp: "URL para cadastrar no webhook da Meta",
          metaApplicationRequired: "Informe nome, App ID e App Secret.",
          metaApplicationSaved: "Aplicativo Meta salvo com segurança.",
          metaApplicationRemoved: "Aplicativo Meta removido.",
          selectQueueRequired: "Selecione a fila para novos contatos.",
          secretKeepCurrent: "Deixe em branco para manter a credencial já salva com segurança.",
          popupHelp: "Se o popup for bloqueado, libere popups para este domínio e tente novamente. A conexão criada por Meta continua editável manualmente para ajustes futuros.",
          manualRequired: "Preencha todos os campos da configuração manual.",
          saved: "Conexão oficial salva com sucesso.",
          tested: "Conexão testada com sucesso.",
          templatesSynced: "Templates sincronizados com sucesso.",
          friendlyNamesSaved: "Nomes amigaveis salvos.",
          templateFieldsRequired: "Informe nome tecnico e texto principal do template.",
          templateSubmitted: "Template enviado para aprovação da Meta.",
          metaCancelled: "Fluxo da Meta cancelado antes da conclusao.",
          metaAuthFailed: "Falha na autenticação com a Meta.",
          metaReturnFailed: "Não foi possível concluir o retorno da Meta.",
          metaStartFailed: "Não foi possível iniciar o fluxo da Meta.",
          finishMetaSetup: "Finalize o login da Meta na janela aberta para concluir a conexão automaticamente.",
          created: "Conexão oficial criada com sucesso.",
          diagnosisPending: "Conexão criada, mas o diagnóstico encontrou pendências.",
          diagnosisConnectionName: "WhatsApp Oficial",
          templates: {
            createTitle: "Criar template na Meta",
            createHelp: "Use variáveis com nomes claros e informe um exemplo para cada uma. O template será enviado para análise da Meta e só poderá ser usado quando estiver aprovado.",
            technicalName: "Nome técnico (Meta)",
            technicalNameHelp: "Use apenas letras minúsculas, números e underscore.",
            friendlyName: "Nome amigável (interno)",
            category: "Categoria",
            language: "Idioma",
            parameterFormat: "Formato das variáveis",
            namedFormat: "Por nome — recomendado",
            positionalFormat: "Por posição — avançado",
            namedHelp: "Mais fácil de configurar e manter. Use nomes como nome e data.",
            positionalHelp: "Compatibilidade com templates antigos. Use posições numeradas em sequência.",
            insertVariable: "Inserir uma variável comum",
            body: "Texto principal (BODY)",
            bodyNamedHelp: "Use os botões acima ou digite variáveis com nomes em minúsculas.",
            bodyPositionalHelp: "Use variáveis numeradas em sequência, começando pela posição 1.",
            exampleFor: "Exemplo para {{variable}}",
            createAction: "Enviar para análise da Meta",
            mixedVariablesError: "Não misture variáveis por nome e por posição no mesmo template.",
            namedFormatError: "No formato recomendado, use variáveis com nomes em vez de números.",
            positionalFormatError: "No formato por posição, use somente números em sequência.",
            examplesRequired: "Informe um exemplo para cada variável antes de enviar para a Meta.",
          },
        },
        diagnosis: {
          title: "Diagnostico Meta - {{name}}",
          retry: "Retestar",
          close: "Fechar",
          labels: {
            pageId: "Page ID",
            verifyToken: "Verify Token",
            webhookUrl: "URL do Webhook",
            secrets: "Credenciais salvas",
            pageAccessToken: "Page Access Token",
            pageTokenMatch: "Token x Página",
            pageWebhookSubscription: "Assinaturas da Página",
            recentInbound: "Recebimento de mensagens",
            diagnose: "Diagnostico geral",
            defaultCheck: "Verificação",
            webhookMeta: "Webhook Meta",
          },
          webhookUnavailable: "Diagnostico de webhook indisponível.",
          expectedVsMeta: "Esperado: {{expected}} | Meta: {{meta}}",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        form: {
          name: "Nome",
          default: "Padrão",
          defaultUser: "Usuario para novos contatos",
          farewellMessage: "Mensagem de despedida",
          outboundQueues: "Filas autorizadas para atendimentos ativos",
          outboundQueuesHelp: "Estas filas poderão selecionar esta conexão ao criar um atendimento manual."
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          saving: "Salvando...",
          cancel: "Cancelar",
        },
        success: "WhatsApp salvo com sucesso.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.",
          importMessage: "Deseja importas todos os contatos do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Ações",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          numberHelp: "Brasil (+55) é aplicado automaticamente. Você pode colar o número com espaços, parênteses ou hífens.",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
        },
        validation: {
          nameTooShort: "Informe pelo menos 2 caracteres.",
          nameTooLong: "O nome deve ter no máximo 50 caracteres.",
          nameRequired: "Informe o nome.",
          numberRequired: "Informe o número do WhatsApp.",
          numberInvalid: "Informe um telefone válido com DDD. O código +55 será incluído automaticamente.",
          emailInvalid: "Informe um e-mail válido.",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          saving: "Salvando...",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      quickAnswersModal: {
        title: {
          add: "Adicionar Resposta Rápida",
          edit: "Editar Resposta Rápida",
        },
        form: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          saving: "Salvando...",
          cancel: "Cancelar",
        },
        success: "Resposta Rápida salva com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar fila",
          edit: "Editar fila",
        },
        tabs: {
          basicData: "Dados básicos",
          integrations: "Integrações",
        },
        form: {
          name: "Nome",
          color: "Cor",
          greetingMessage: "Mensagem de saudação",
          startAttendanceMessage: "Mensagem ao Iniciar o Atendimento",
          finishAttendanceMessage: "Mensagem ao Finalizar o Atendimento",
          allowManualAttendance: "Permitir atendimento manual nesta fila",
          allowAiAgents: "Permitir agentes de IA nesta fila",
          allowAiAgentsHelp: "Quando desativado, nenhum usuário do tipo Agente de IA poderá assumir atendimentos desta fila.",
          aiHandoffQueue: "Fila para repasse humano",
          aiHandoffQueueNone: "Sem fila padrão de repasse",
          aiHandoffQueueHelp: "Quando o agente de IA precisar passar para uma pessoa sem indicar usuário ou setor, o atendimento será movido para esta fila.",
        },
        integrations: {
          empty: "Nenhuma integração adicionada.",
          integrationLabel: "Integração {{number}}",
          buttons: {
            add: "Adicionar integração",
          },
          form: {
            type: "Tipo de integração",
            name: "Nome da integração",
            webhookUrl: "URL do webhook",
            triggerEvents: "Eventos disparadores",
            contact: "Contato",
            specificContacts: "Contatos específicos",
            searchContactPlaceholder: "Digite para buscar contatos",
            token: "Token (opcional)",
            status: "Status",
          },
          types: {
            webhook: "Webhook",
            flowch: "Flowch",
          },
          flowch: {
            form: {
              endpointUrl: "URL da integração Flowch",
              docUrl: "Documento carregado",
              fieldMappings: "Mapeamento de campos",
              mappingLabel: "Campo {{number}}",
              fieldName: "Nome do campo",
              fieldLabel: "Texto de ajuda",
              valueMode: "Tipo de valor",
              source: "Origem no Talk",
              fixedValue: "Valor fixo",
            },
            buttons: {
              loadDoc: "Ler processo",
              addField: "Adicionar campo",
            },
            messages: {
              endpointRequired: "Informe a URL da integração para ler o processo.",
              docLoaded: "Processo lido com sucesso. Campos carregados para mapeamento.",
            },
            boolean: {
              yes: "Sim",
              no: "Não",
            },
            valueMode: {
              talk: "Origem no Talk",
              fixed: "Valor fixo",
            },
            sources: {
              ticketId: "ID do atendimento",
              messageId: "ID da mensagem",
              contactId: "ID do contato",
              contactNumber: "Número do contato",
              contactLid: "LID do contato",
              contactIsGroup: "Contato e grupo",
              messageContactId: "ID do autor da mensagem",
              messageContactName: "Nome do autor da mensagem",
              messageContactNumber: "Numero do autor da mensagem",
              participantContactId: "ID do participante do grupo",
              participantName: "Nome do participante do grupo",
              participantNumber: "Numero do participante do grupo",
              participantLid: "LID do participante do grupo",
              groupContactId: "ID do grupo",
              groupName: "Nome do grupo",
              groupNumber: "Numero do grupo",
              messageBody: "Corpo da mensagem",
              fromMe: "Mensagem enviada pelo agente",
              mémediaType: "Tipo de mídia",
              ticketStatus: "Status do atendimento",
              userId: "ID do usuário",
              whatsappId: "ID da conexão",
              whatsappName: "Nome da conexão",
              connectionId: "ID da conexão genérica",
              connectionName: "Nome da conexão genérica",
              channel: "Canal",
              provider: "Provedor",
              event: "Evento da integração",
              queueId: "ID da fila",
              timestamp: "Data/hora do disparo",
              fixed: "Valor fixo",
            },
          },
          status: {
            active: "Ativo",
            inactive: "Inativo",
          },
          contactScope: {
            all: "Todos os contatos",
            specific: "Contato específico",
          },
          events: {
            messageReceived: "Mensagem recebida",
            messageSent: "Mensagem enviada",
            conversationStarted: "Conversa iniciada",
            conversationFinished: "Conversa finalizada",
          },
          test: {
            button: "Testar integração",
            resultTitle: "Resultado do teste",
            requestData: "Dados enviados",
            responseData: "Dados de retorno",
            messages: {
              success: "Teste executado com sucesso.",
            },
          },
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          saving: "Salvando...",
          cancel: "Cancelar",
        },
      },
      userModal: {
        configuration: {
  "legacyTitle": "Opções do modo anterior",
  "legacyHelp": "Usadas por agentes sem as novas regras de atendimento. Seus valores continuam salvos quando o modo muda.",
  "advancedTitle": "Configurações avançadas de IA",
  "advancedHelp": "Provedor, modelo e limites. Altere somente se souber o efeito no comportamento e no consumo.",
  "knowledgeTitle": "Conhecimento e capacidades",
  "knowledgeHelp": "Organize informações sobre serviços, profissionais, preços e outras especialidades. Capacidades de integração também permanecem aqui; permissões do atendimento ficam em suas próprias opções.",
  "permissionsTitle": "Permissões adicionais",
  "permissionsHelp": "Defina se o agente pode consultar o contexto, registrar notas e atualizar o contato. As transferências do modo atual são configuradas em Transferências.",
  "saved": "Configuração salva.",
  "synced": "Configuração salva e sincronizada com o Agents.",
  "syncPending": "Configuração salva, mas a sincronização com o Agents não foi confirmada. Revise o estado antes de usar o agente.",
  "draftSaved": "Rascunho salvo. O agente não foi publicado.",
  "statusTitle": "Estado do agente",
  "statusReady": "Ativo e pronto",
  "statusDraft": "Rascunho",
  "statusPending": "Precisa de revisão",
  "statusHelp": "Este é o estado da última configuração salva. Alterações nesta tela só serão aplicadas ao salvar."
},
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        creationChoice: {
          title: "Quem você quer adicionar?",
          help: "Escolha uma opção para abrir somente as configurações necessárias.",
          humanTitle: "Pessoa",
          humanDescription: "Crie um acesso para atendentes, gestores ou administradores da equipe.",
          aiTitle: "Agente de IA",
          aiDescription: "Use um passo a passo simples para escolher o segmento, as capacidades e o comportamento do agente.",
          humanSelected: "Novo usuário da equipe",
          humanSelectedHelp: "Preencha os dados de acesso e atendimento.",
          aiSelected: "Novo agente de IA",
          aiSelectedHelp: "O assistente guiado aparece logo abaixo da identificação.",
          changeType: "Trocar tipo",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          profile: "Perfil",
          userType: "Tipo de usuário",
          userTypeOptions: {
            human: "Humano",
            aiAgent: "Agente de IA",
          },
          language: "Idioma",
          profilePic: "Foto do usuário",
          ticketOrder: "Ordem dos atendimentos",
          ticketOrderOptions: {
            oldestFirst: "Mais antigos primeiro",
            newestFirst: "Mais novos primeiros",
          },
          whatsapp: "Conexão Padrão",
        },
        sections: {
          userData: "Dados do usuário",
          userDataHelp: "Defina identificação, tipo de usuário e preferências gerais.",
          attendance: "Atendimento",
          attendanceHelp: "Configure as filas e a conexão padrão usadas por este usuário.",
        },
        humanWizard: {
          steps: {
            access: "Acesso",
            service: "Permissões",
            review: "Revisão",
          },
          accessTitle: "Como esta pessoa vai acessar o Talk?",
          accessHelp: "Informe apenas os dados necessários para criar o acesso. Os demais ajustes podem ser feitos depois.",
          nameHelp: "Use o nome pelo qual a equipe reconhece esta pessoa.",
          emailHelp: "Este será o email usado para entrar no Talk.",
          passwordHelp: "Crie uma senha inicial com pelo menos 5 caracteres e envie-a por um canal seguro.",
          togglePassword: "Mostrar ou ocultar senha",
          serviceTitle: "O que esta pessoa poderá acessar?",
          serviceHelp: "Escolha o nível de permissão e direcione os atendimentos. Filas e conexão podem ser alteradas depois.",
          roles: {
            agent: {
              title: "Atendente",
              help: "Atende conversas e usa os recursos liberados pelo administrador.",
            },
            admin: {
              title: "Administrador",
              help: "Configura a empresa, gerencia usuários, conexões e todos os atendimentos.",
            },
          },
          queuesTitle: "Filas de atendimento",
          queuesHelp: "Selecione os assuntos ou equipes que esta pessoa poderá atender. É possível continuar sem escolher uma fila.",
          queuesLabel: "Selecionar filas",
          noDefaultConnection: "Sem conexão padrão",
          reviewTitle: "Revise antes de criar o acesso",
          reviewHelp: "Confira os dados abaixo. A senha não é exibida por segurança.",
          review: {
            person: "Pessoa",
            access: "Email de acesso",
            role: "Permissão",
            service: "Atendimento",
            queueCount: "{{count}} fila(s) selecionada(s)",
            noQueues: "Todas ou nenhuma fila específica",
          },
          preferencesTitle: "Preferências opcionais",
          preferencesHelp: "Idioma da interface e ordem dos atendimentos já vêm com valores recomendados.",
          afterCreateHelp: "Foto, horário de acesso e outros detalhes podem ser configurados depois, ao editar o usuário.",
          create: "Criar usuário",
        },
        aiAgent: {
          title: "Perfil do agente de IA",
          help: "Configure o comportamento principal deste usuário agente. A sincronização com o Flowch Agents acontece pelo backend.",
          description: "Descrição",
          instructions: "Instruções do agente",
          llmProvider: "Provedor LLM",
          llmModel: "Modelo LLM",
          temperature: "Temperatura",
          maxTokens: "Limite máximo de tokens",
          mediaTitle: "Arquivos recebidos",
          mediaHelp: "Defina quais tipos de arquivo este agente pode enviar ao Flowch Agents. O Talk não salva transcrições; apenas encaminha o arquivo quando permitido.",
          allowAudioMessages: "Permitir áudios",
          allowImageMessages: "Permitir imagens",
          allowDocumentMessages: "Permitir documentos",
          maxMediaFileSizeMb: "Tamanho máximo por arquivo (MB)",
          responseDelaySeconds: "Aguardar mensagens por segundos",
          proactiveDelayMinutes: "Mensagem ativa após minutos sem resposta",
          maxProactiveMessages: "Máximo de mensagens ativas antes de fechar",
          proactivePrompt: "Prompt da mensagem ativa",
          unavailableMessage: "Mensagem quando a IA estiver indisponível",
          unavailableMessageHelp: "Enviada quando o Agents estiver indisponível ou sem créditos. No modo operacional, também é usada quando o retorno não é válido. Deixe vazio para usar a mensagem padrão. Mensagens ativas não disparam este aviso ao contato.",
          failureTitle: "Contingência por falha do atendimento",
          failureHelp: "O Talk não repete automaticamente a chamada para corrigir uma falha. Envia este aviso uma vez e pausa a IA no ticket. Para retomar, a equipe deve assumir o atendimento e depois atribuí-lo novamente ao agente, após resolver a causa. A pausa impede mensagens ativas e fechamento por inatividade.",
          failureTransfer: "Transferir para uma fila em caso de falha",
          failureQueue: "Fila de contingência",
          failureQueueHelp: "Escolha uma fila que permita atendimento manual e não atribua tickets automaticamente à IA. Sem transferência habilitada, o atendimento permanece com a IA pausada e uma atividade para revisão da equipe. Esta regra também cobre falta de créditos e retorno inválido.",
          failureQueueSelect: "Selecione uma fila de atendimento humano",
          failureQueueUnavailable: "Fila salva indisponível para contingência",
          failureUnsupported: "A configuração de contingência usa uma versão não suportada. Preserve os dados e solicite revisão.",
          proactiveClosureKeywords: "Frases que fecham em silêncio",
          proactiveClosureKeywordsHelp: "Campo mantido para compatibilidade. Prefira usar o prompt de fechamento em silêncio.",
          proactiveClosurePrompt: "Prompt para fechamento em silêncio",
          proactiveClosurePromptHelp: "Instrução enviada ao Flowch Agents para decidir se a última resposta do contato permite fechar o atendimento sem enviar nova mensagem. Peça uma resposta apenas em JSON com shouldClose, confidence e reason.",
          proactiveCloseSilently: "Fechar em silêncio quando o contato confirmar que resolveu",
          allowDirectTicketClosure: "Permitir que o agente encerre atendimentos diretamente",
          allowDirectTicketClosureHelp: "Desativado: o agente continua atendendo e somente o fluxo configurado de mensagens ativas ou inatividade pode encerrar o ticket.",
          operationalSkills: {
            title: "Ferramentas operacionais",
            help: "Ative apenas as ações que este agente realmente precisa. Menos ferramentas reduzem decisões desnecessárias e respostas técnicas. A transferência é a configuração recomendada para novos agentes.",
            items: {
              talk_handoff: {
                label: "Transferir atendimentos",
                help: "Permite encaminhar para uma fila, pessoa ou outro agente de IA, preservando o atendimento."
              },
              talk_query_context: {
                label: "Consultar contexto operacional",
                help: "Disponibiliza listas de filas e atendentes. Ative somente quando o agente precisar pesquisar destinos antes de transferir."
              },
              talk_add_internal_note: {
                label: "Registrar notas internas",
                help: "Permite adicionar registros internos auditáveis ao atendimento."
              },
              talk_update_contact: {
                label: "Atualizar dados do contato",
                help: "Permite alterar nome, e-mail ou número do contato durante o atendimento."
              }
            }
          },
          loopHandoffQueue: "Fila para repasse se detectar loop de IA",
          smartHandoff: "Transferências inteligentes",
          smartHandoffHelp: "Permite que o agente entenda pedidos naturais, consulte pessoas e filas disponíveis e transfira somente após validação do Flowch Talk. Vem ativado por padrão.",
          loopHandoffQueueNone: "Usar fila de repasse da fila atual",
          dissatisfactionEscalation: "Escalonar contatos insatisfeitos",
          dissatisfactionEscalationQueue: "Fila responsável pelo atendimento",
          dissatisfactionEscalationQueueNone: "Selecione a fila responsável",
          dissatisfactionEscalationHelp: "O agente tenta contornar a insatisfação uma vez. Se ela continuar ou houver pedido de gerente ou responsável, transfere para esta fila sem repetir perguntas.",
          signMessages: "Enviar assinatura nas mensagens do agente",
          capabilitiesTitle: "Capacidades de atendimento",
          capabilitiesHelp: "Use capacidades para orientar subagentes especialistas sem criar outros usuários no Talk.",
          addCapability: "Adicionar capacidade",
          removeCapability: "Remover capacidade",
          capabilityName: "Nome da capacidade",
          capabilityType: "Tipo da capacidade",
          capabilityDescription: "Descrição resumida",
          capabilityInstructions: "Instruções da capacidade",
          capabilityEnabled: "Ativa",
          wizard: {
            loading: "Carregando modelos de agente...",
            title: "Criação guiada do agente",
            help: "Escolha o segmento, habilite capacidades e informe somente os dados necessários. O Talk monta as instruções técnicas por você.",
            advancedMode: "Configuração técnica",
            guidedMode: "Voltar para criação guiada",
            modeDraftPreserved: "A configuração do outro modo foi preservada e poderá ser restaurada.",
            modeSwitchToGuidedConfirm: "A criação guiada substituirá a configuração técnica quando você salvar. Deseja continuar?",
            steps: {
              objective: "Objetivo",
              knowledge: "Conhecimento",
              capabilities: "Capacidades",
              behavior: "Comportamento",
              review: "Revisão",
            },
            objectiveTitle: "Dê uma identidade e escolha o segmento",
            objectiveHelp: "O Talk usará essas escolhas para preparar uma base segura e adequada ao tipo de atendimento.",
            agentName: "Nome do agente",
            agentNameHelp: "Use um nome curto e fácil de reconhecer, como Nair ou Assistente da Clínica.",
            segmentTitle: "Qual é o segmento deste agente?",
            segmentHelp: "O modelo define uma base segura e pode ser personalizado nas próximas etapas.",
            templates: {
              medicalClinic: "Clínicas e saúde",
              medicalClinicDescription: "Atendimento administrativo, dúvidas, profissionais e consultas.",
              technologyCompany: "Tecnologia e SaaS",
              technologyCompanyDescription: "Produto, oportunidades, demonstrações e triagem de suporte.",
              otherBusiness: "Outro segmento",
              otherBusinessDescription: "Modelo flexível para serviços, comércio e outros negócios.",
            },
            capabilitiesTitle: "O que o agente poderá fazer?",
            capabilitiesHelp: "Ative apenas o que já pode ser sustentado pelas informações e integrações da empresa.",
            advancedBadge: "Avançada",
            recommendedBadge: "Recomendada",
            integrationBadge: "Pode exigir integração",
            capabilities: {
              faq: "FAQ e dúvidas frequentes",
              faqDescription: "Responde perguntas usando as informações cadastradas.",
              scheduling: "Agendamento",
              schedulingDescription: "Orienta ou agenda por link e integração configurados.",
              appointmentManagement: "Confirmação e alteração de consultas",
              appointmentManagementDescription: "Confirma, altera ou cancela pelo fluxo autorizado.",
              professionalsSpecialties: "Profissionais e especialidades",
              professionalsSpecialtiesDescription: "Informa médicos, especialistas, unidades e serviços.",
              coveragePrices: "Convênios e valores",
              coveragePricesDescription: "Informa cobertura, particular e preços cadastrados.",
              advancedOperations: "Operações avançadas",
              advancedOperationsDescription: "Executa ações autorizadas em sistemas conectados.",
              technologyFaqDescription: "Responde dúvidas de produto com a documentação aprovada.",
              leadQualification: "Qualificação de oportunidades",
              leadQualificationDescription: "Entende necessidade, contexto, prazo e contato.",
              demoScheduling: "Agendamento de demonstrações",
              demoSchedulingDescription: "Agenda demonstrações pelo fluxo configurado.",
              supportTriage: "Triagem de suporte",
              supportTriageDescription: "Coleta contexto e direciona para a fila adequada.",
              advancedIntegrations: "Integrações avançadas",
              advancedIntegrationsDescription: "Executa operações configuradas com confirmação segura.",
              customerIntake: "Entendimento da solicitação",
              customerIntakeDescription: "Faz perguntas curtas para direcionar corretamente.",
              generalSchedulingDescription: "Agenda serviços pelo link ou integração configurada.",
            },
            businessTitle: "Ensine o essencial sobre o negócio",
            businessHelp: "Essas informações serão a fonte aprovada do agente. Não inclua senhas, tokens ou segredos.",
            moreKnowledgeTitle: "Adicionar informações úteis",
            moreKnowledgeHelp: "Horários, endereço, link de agendamento e regras específicas são opcionais.",
            fields: {
              organizationName: "Nome da empresa ou unidade",
              businessHours: "Horários de atendimento",
              summary: "Como você explicaria o negócio para um novo atendente?",
              summaryHelp: "Explique público, objetivo e limites do atendimento.",
              services: "Serviços, especialidades, produtos ou informações disponíveis",
              address: "Endereços e unidades",
              schedulingUrl: "Link autorizado de agendamento",
              schedulingUrlHelp: "Se ficar vazio, o agente não confirmará agendamentos automaticamente.",
              schedulingUrlRequiredHelp: "Obrigatório para capacidades de agendamento. Use um link completo iniciado por http:// ou https://.",
              advancedOperations: "Quais operações avançadas estão autorizadas?",
              advancedOperationsRequiredHelp: "Descreva exatamente o que pode ser executado e quais confirmações são obrigatórias.",
              noHandoffQueue: "Usar a fila de repasse da fila atual",
              additionalRules: "Regras adicionais",
              additionalRulesHelp: "Informe políticas reais do negócio. As regras obrigatórias de segurança continuam ativas.",
            },
            behaviorTitle: "Defina como o agente deve atuar",
            behaviorHelp: "Os nomes técnicos de modelo, temperatura e tokens são gerenciados pelo Talk.",
            optionalBehaviorTitle: "Ajustes opcionais de resposta e autonomia",
            optionalBehaviorHelp: "Os padrões recomendados já estão selecionados. Altere somente se sua operação precisar.",
            routingTitle: "Onde o agente vai atender?",
            routingHelp: "Escolha ao menos uma fila e a conexão pela qual as conversas chegarão. Isso evita publicar um agente sem entrada de atendimento.",
            queuesLabel: "Filas atendidas pelo agente",
            selectConnection: "Selecione uma conexão",
            routingRequired: "Resolva os itens destacados: capacidade, fila, conexão e, quando exigido, link ou regras da operação.",
            behavior: {
              intelligenceProfile: {
                title: "Inteligência",
                help: "Escolha o equilíbrio entre velocidade, custo e profundidade.",
                essential: "Essencial — rápida e econômica",
                balanced: "Equilibrada — recomendada",
                advanced: "Profunda — casos complexos",
              },
              tone: {
                title: "Tom de voz",
                help: "Como o agente deve conversar com seus clientes.",
                welcoming: "Acolhedor",
                professional: "Profissional",
                casual: "Próximo e natural",
                technical: "Técnico",
              },
              responseLength: {
                title: "Tamanho das respostas",
                help: "A profundidade não muda; apenas a forma de apresentar.",
                short: "Curtas",
                balanced: "Equilibradas",
                detailed: "Detalhadas",
              },
              autonomyLevel: {
                title: "Autonomia",
                help: "Controle se o agente somente orienta ou também executa ações.",
                answer_only: "Apenas responde",
                suggest_actions: "Sugere ações",
                confirm_actions: "Executa após confirmação",
                automatic: "Automática para ações autorizadas",
              },
            },
            reviewTitle: "Proteções incluídas nesta configuração",
            review: {
              agent: "Agente",
              segment: "Segmento",
              capabilities: "Capacidades ativas",
              queues: "Filas",
              connection: "Conexão padrão",
              behavior: "Comportamento",
              usage: "Uso estimado",
              safePrompt: "Regras obrigatórias do segmento são adicionadas automaticamente.",
              humanHandoff: "Solicitações fora do escopo oferecem transferência humana.",
              onlyEnabled: "Somente capacidades habilitadas entram nas instruções do agente.",
              versionedTemplate: "O modelo e a versão usados ficam registrados para futuras atualizações.",
            },
            readyToPublish: "Configuração revisada",
            finalReviewTitle: "Tudo pronto para publicar?",
            finalReviewHelp: "O Talk verificou os itens necessários. Volte a uma etapa se quiser fazer algum ajuste.",
            readiness: {
              name: "Nome do agente",
              template: "Modelo do segmento",
              organization: "Informações da organização",
              capabilities: "Capacidades habilitadas",
              connection: "Conexão padrão",
              queues: "Fila de atendimento",
              scheduling: "Link para agendamento",
              operations: "Regras das operações avançadas",
              autonomy: "Limites de autonomia",
              ready: "Configurado",
              missing: "Precisa de ajuste",
            },
            usage: {
              title: "Estimativa de uso",
              summary: "Até {{tokens}} tokens por resposta · consumo relativo {{cost}}",
              help: "É uma referência de limite e consumo. O valor financeiro real depende do provedor, do contrato e do volume de contexto.",
              cost: { low: "baixo", medium: "médio", high: "alto" },
            },
            simulator: {
              title: "Simular antes de publicar",
              help: "Teste uma pergunta em conversa isolada. O simulador não cria ticket, não usa contato real e não envia mensagem ao WhatsApp.",
              message: "Mensagem de teste",
              placeholder: "Ex.: Vocês aceitam o convênio Unimed?",
              run: "Simular resposta",
              running: "Simulando...",
              saveFirst: "Salve como rascunho e reabra o agente para liberar a simulação.",
              operationsNote: "A prévia valida conhecimento, tom e limites. Transferências e outras operações devem ser testadas depois em um canal controlado.",
            },
            testTitle: "Validação recomendada após publicar",
            testHelp: "Depois da criação, envie estas mensagens por um canal de teste antes de direcionar clientes reais:",
            test: {
              knownQuestion: "Uma pergunta comum que esteja nas informações cadastradas.",
              unknownQuestion: "Uma pergunta fora do escopo para confirmar que o agente não inventa respostas.",
              humanRequest: "Um pedido de atendimento humano para validar a transferência.",
            },
            back: "Voltar",
            next: "Continuar",
            finishReview: "Concluir revisão",
            saveDraft: "Salvar rascunho",
            draftSaved: "Rascunho do agente salvo com sucesso.",
            publish: "Publicar agente",
          },
        },
        accessSchedule: {
          title: "Horário de acesso",
          help: "Controle quando este usuário pode acessar ou quando este agente de IA pode responder. As mensagens continuam sendo recebidas normalmente e ficam aguardando o próximo horário permitido.",
          enabled: "Ativar controle de horário",
          profile: "Perfil de horário",
          customProfile: "Configuração personalizada",
          saveAsProfileName: "Salvar esta configuração como perfil",
          saveAsProfileNameHelp: "Opcional. Use para reaproveitar o mesmo horário em outros usuários.",
          timezone: "Fuso horário",
          daysOfWeek: "Dias permitidos",
          startTime: "Início",
          endTime: "Fim",
          warnBeforeMinutes: "Avisar quantos minutos antes do fim",
          forceLogoutHumans: "Forçar logout de usuários humanos fora do horário",
          pauseAiOutsideHours: "Pausar agentes de IA fora do horário",
          blockHumanActionsOutsideHours: "Bloquear ações humanas fora do horário",
          temporaryOverrideTitle: "Liberação temporária",
          temporaryOverrideHelp: "Use quando o administrador precisar liberar mais tempo para este usuário sem alterar o horário padrão.",
          temporaryOverrideUntil: "Liberar acesso até",
          temporaryOverrideReason: "Motivo da liberação",
          warningToast: "Em {{minutes}} min. você será deslogado porque está próximo do fim do expediente.",
          forceLogoutToast: "Seu horário de acesso terminou. Você foi deslogado automaticamente.",
          weekdays: {
            sun: "Domingo",
            mon: "Segunda",
            tue: "Terça",
            wed: "Quarta",
            thu: "Quinta",
            fri: "Sexta",
            sat: "Sábado"
          }
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          saving: "Salvando...",
          cancel: "Cancelar",
        },
        validation: {
          required: "Campo obrigatório",
          tooShort: "Informe pelo menos 2 caracteres",
          tooLong: "O valor informado é muito longo",
          passwordMinimum: "A senha deve ter pelo menos 5 caracteres",
          invalidEmail: "Informe um email válido",
        },
        success: "Usuário salvo com sucesso.",
      },
      chat: {
        noTicketMessage: "Selecione um atendimento para começar a conversar.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
        },
      },
      ticketsUserSelect: {
        placeholder: "Atendentes",
        all: "Todos",
        unassigned: "Sem atendente",
        only: "Somente",
        onlyTooltip: "Filtrar somente este item",
        allTooltip: "Mostrar todos",
        selectAllTooltip: "Selecionar todos",
        clearAllTooltip: "Deselecionar todos",
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
        all: "Todas",
        noQueue: "Sem fila",
        only: "Somente",
        onlyTooltip: "Filtrar somente este item",
        allTooltip: "Mostrar todas",
        selectAllTooltip: "Selecionar todas",
        clearAllTooltip: "Deselecionar todas",
      },
      tickets: {
        toasts: {
          deleted: "O atendimento em que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar atendimentos e mensagens",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Atendimento",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldConnectionLabel: "Transferir para conexão",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldConnectionPlaceholder: "Selecione uma conexão",
        noOptions: "Nenhum usuário encontrado com esse nome",
        noQueueUsers: "Nenhum atendente encontrado nesta fila",
        queueUsersLabel: "Atendentes disponíveis na fila de destino",
        loadingQueueUsers: "Carregando atendentes da fila...",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        connectionTitle: "Conexão que está sendo utilizada atualmente.",
        closedTag: "Resolvido",
        groupTag: "Grupo",
        buttons: {
          accept: "Atender",
        },
      },
      groupParticipantsModal: {
        title: "Participantes do grupo",
        ticketTitle: "Participantes do atendimento",
        openButton: "Gerenciar participantes do grupo",
        description:
          "Escolha quais usuários internos podem acompanhar este grupo no Flowch Talk. Isso não altera os membros reais do grupo no WhatsApp; controla apenas quem acompanha e interage por aqui.",
        ticketDescription:
          "Escolha quais usuários internos podem acompanhar e interagir neste atendimento sem alterar o atendente responsável.",
        userLabel: "Usuário",
        userPlaceholder: "Selecione um usuário",
        empty: "Nenhum participante interno adicionado ainda.",
        roles: {
          admin: "Admin",
          member: "Participante",
          viewer: "Leitor",
        },
        buttons: {
          add: "Adicionar",
          remove: "Remover participante",
          close: "Fechar",
        },
        toasts: {
          added: "Participante adicionado.",
          removed: "Participante removido.",
        },
      },
      newTicketModal: {
        title: "Criar Atendimento",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        queueLabel: "Fila",
        queuePlaceholder: "Selecione uma fila",
        userLabel: "Atendente",
        userPlaceholder: "Selecione um atendente",
        loadingUsers: "Carregando atendentes...",
        connectionLabel: "Conexão",
        connectionPlaceholder: "Selecione a conexão",
        loadingConnections: "Carregando conexões...",
        noConnections: "Nenhuma conexão ativa disponível",
        noQueueUsers: "Nenhuma fila disponível para seu usuário",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          tickets: "Atendimentos",
          indicators: "Indicadores",
          contacts: "Contatos",
          quickAnswers: "Respostas Rápidas",
          queues: "Filas",
          administration: "Administração",
          users: "Usuários",
          settings: "Configurações",
        },
        connectionWarning: "Há conexão QR Code precisando de atenção.",
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
      },
      queues: {
        title: "Filas",
        table: {
          id: "ID",
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          aiAgents: "Agentes de IA",
          actions: "Ações",
        },
        aiAgents: {
          enabled: "Permitido",
          disabled: "Bloqueado",
        },
        buttons: {
          add: "Adicionar fila",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queueSelect: {
        inputLabel: "Filas",
      },
      quickAnswers: {
        title: "Respostas Rápidas",
        table: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Resposta Rápida",
        },
        toasts: {
          deleted: "Resposta Rápida excluída com sucesso.",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle:
            "Você tem certeza que quer excluir esta Resposta Rápida: ",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
      },
      users: {
        title: "Usuários",
        table: {
          id: "ID",
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          type: "Tipo",
          whatsapp: "Conexão Padrão",
          status: "Status",
          actions: "Ações",
        },
        userTypes: {
          human: "Humano",
          ai_agent: "Agente de IA",
        },
        status: {
          online: "Online",
          offline: "Offline",
        },
        aiStatus: {
          ready: "Pronto",
          draft: "Rascunho",
          pending_config: "Configurar",
          pending_sync: "Sincronizando",
          error: "Erro",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os atendimentos abertos deste usuário serão movidos para a fila.",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        apiDocs: {
          copied: "Copiado para a área de transferência!",
          intro: "Defina regras globais do atendimento e consulte os dados para integrações externas. Use o token com cuidado e prefira informar o connectionId em novas integrações.",
          generalTitle: "Configurações gerais",
          generalDescription: "Controles de comportamento usados em toda a operação.",
          apiTitle: "Integrações via API",
          apiDescription: "Token, endpoints e exemplos para sistemas externos enviarem mensagens e controlarem atendimentos.",
          tokenTitle: "Token de API",
          tokenHelp: "Use este token no header de autorização. Evite compartilhar em prints, URLs ou mensagens públicas.",
          copyToken: "Copiar Token",
          quickDocTitle: "Documentação rápida da API",
          overview: "Visão geral",
          overviewToken: "Use o token acima no header Authorization: Bearer SEU_TOKEN.",
          overviewNumber: "O número aceita espaços, parênteses, hífens e prefixo +. Se um telefone brasileiro vier apenas com DDD, o DDI 55 será incluído automaticamente. Exemplo normalizado: 5519978175005.",
          overviewConnection: "Informe connectionId nas integrações novas para escolher a conexão correta.",
          overviewTransfer: "Se quiser um endpoint mais explícito para transferência, use /transfer.",
          overviewResolve: "Para encerrar um atendimento aberto pelo número do contato, use /resolve.",
          requiredHeaders: "Headers obrigatórios",
          sendMessage: "1. Enviar mensagem",
          sendDescription: "Use este endpoint para enviar uma mensagem e, no mesmo request, direcionar o atendimento para uma fila e um usuário específicos.",
          transferQueue: "2. Trocar de fila",
          transferDescription: "Use este endpoint para transferir o atendimento para uma fila e, opcionalmente, atribuí-lo a um usuário dessa fila. Também é possível enviar uma mensagem junto.",
          sendTemplate: "3. Enviar template do WhatsApp Oficial",
          templateDescription: "Use este endpoint para iniciar ou retomar uma conversa pelo WhatsApp Oficial com um template aprovado pela Meta. Também é possível definir a fila e o usuário responsável.",
          templateConnectionIdHint: "Para WhatsApp Oficial, use o ID exibido na tela de Conexões. A fila informada deve pertencer ao mesmo cliente da conexão.",
          templateConnectionRequired: "obrigatório; aceita o ID exibido na tela de Conexões para uma conexão de WhatsApp Oficial",
          templateNameRequired: "nome exato do template aprovado na Meta",
          templateLanguage: "código do idioma aprovado, por exemplo pt_BR",
          templateParameters: "objeto com valores por nome para templates nomeados, como nome e data; templates posicionais antigos continuam aceitando uma lista na ordem das variáveis",
          resolveConversation: "4. Finalizar atendimento",
          resolveDescription: "Finaliza o atendimento aberto mais recente do contato. O encerramento segue as mesmas regras da ação manual no Flowch Talk.",
          resolveNumberRequired: "único campo obrigatório; aceita número formatado e inclui 55 automaticamente em telefones brasileiros com DDD",
          resolveBehavior: "Ao finalizar, o sistema envia a mensagem de encerramento configurada na fila, registra o histórico, atualiza a tela em tempo real e executa as integrações de fim de atendimento. Se houver despedida legada na conexão, ela também será enviada.",
          resolveSuccess: "Resposta de sucesso:",
          resolveValidation: "Validação recomendada: confirme status closed na resposta e verifique se o atendimento saiu das listas Atendendo/Aguardando. Se a fila possuir mensagem final, confirme também o registro dela na conversa.",
          resolveAlreadyClosed: "Se o atendimento mais recente deste número já estiver fechado, a API retorna 409 com ERR_API_TICKET_ALREADY_CLOSED. Use este retorno para tratar a chamada como duplicada ou já processada.",
          resolveMethod: "Este endpoint aceita apenas POST. Chamadas GET retornam 405 com ERR_API_RESOLVE_METHOD_NOT_ALLOWED.",
          recommendedNew: "recomendado para novas integrações",
          required: "obrigatório",
          requiredWithoutMedia: "obrigatório quando não houver mídia",
          optionalQueue: "opcional, mas recomendado quando você já quer encaminhar o atendimento",
          optionalUser: "opcional; ID do usuário que ficará responsável pelo atendimento",
          userAssignmentValidation: "Ao informar userId, a API valida se o usuário pertence à mesma empresa, está habilitado para a fila resolvida e, no caso de agente de IA, se a fila permite IA e o agente está pronto. Se queueId for omitido, será usada a fila já resolvida no atendimento ou na conexão.",
          aiContextHandoff: "Quando o atendimento está atribuído a uma IA pronta, o Talk importa o contexto recente ao criar a conversa no Agents. Novos envios pela API entram como contexto incremental na próxima interação. No contrato V2, envios confirmados iniciam os prazos configurados de acompanhamento e inatividade; transferência sem mensagem não inicia prazo. Fora da janela de resposta livre do WhatsApp Oficial, o acompanhamento é omitido e o encerramento por inatividade ocorre sem despedida. Confira a mensagem, o responsável e o status no ticket.",
          successResponse: "Exemplo de resposta de sucesso:",
          optionalLegacy: "opcional, mantido apenas para integrações legadas",
          optional: "opcional",
          javascriptExample: "Exemplo em JavaScript",
          expectedResponses: "Respostas esperadas",
          response200: "operação concluida com sucesso",
          response400: "número, queueId, userId, connectionId ou body inválidos; também ocorre quando o usuário não pertence à fila",
          response409: "a operação exige outra ação ou o agente de IA informado ainda não está pronto",
          response401: "token ausente ou inválido",
          response404: "fila, conexão ou atendimento aberto não encontrado",
          response503: "conexão sem sessão ativa",
        },
        aiAgents: {
          title: "Flowch Agents",
          description: "Chave e endpoint usados pelos agentes de IA deste cliente.",
          help: "Configure a chave do tenant no Flowch Agents. Ela fica criptografada no backend, aparece mascarada depois de salva e nunca é enviada em texto aberto para o frontend.",
          apiUrl: "URL da API",
          apiUrlHelp: "Use o padrão oficial, salvo quando o cliente estiver em um ambiente dedicado.",
          apiKey: "Chave da API",
          apiKeyHelp: "Cole uma nova chave para substituir a atual. Se aparecer mascarada, ela já está configurada.",
          companyWebsite: "Website do cliente",
          companyWebsiteHelp: "Opcional. Em caso de indisponibilidade do Flowch Agents, este endereço será informado ao contato como alternativa para realizar agendamentos. Se ficar vazio, a mensagem mencionará apenas o atendimento por ligação.",
          companyWebsitePlaceholder: "https://www.exemplo.com.br",
          save: "Salvar Flowch Agents",
          internalSkillsTitle: "Skills internas do Talk",
          internalSkillsDescription: "Estas rotas são privadas e chamadas pelo Flowch Agents para executar ações controladas no atendimento. O segredo de assinatura é criado pelo backend e não e exibido na tela.",
          skillQueryContext: "talk_query_context: consulta contexto seguro do atendimento atual.",
          skillRequestHuman: "talk_request_human: solicita atendimento humano e pode mover para a fila de handoff.",
          skillTransferQueue: "talk_transfer_queue: transfere para outra fila que permita agentes de IA.",
          skillCloseAttendance: "talk_close_attendance: finaliza o atendimento usando as regras do Talk.",
          skillAddNote: "talk_add_internal_note: registra nota interna auditável.",
          skillUpdateContact: "talk_update_contact: atualiza nome, email ou número do contato.",
          internalSkillsValidation: "Toda chamada valida assinatura, empresa, ticket, usuário de IA responsável e permissão de IA na fila antes de executar qualquer ação.",
        },
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          allowSignMessageChoice: {
            name: "Permitir o usuário escolher assinatura",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
        },
      },
      messagesList: {
        previousAttendance: {
          load: "Carregar atendimento anterior",
          loading: "Carregando atendimento anterior...",
          none: "Não há atendimento anterior para este contato.",
          title: "Atendimento anterior",
          whatsappHistoryLoad: "Buscar histórico anterior no WhatsApp",
          whatsappHistoryLoading: "Buscando histórico no WhatsApp...",
          whatsappHistoryImported: "{{count}} mensagens sincronizadas.",
          whatsappHistoryEmpty: "Nenhuma mensagem antiga nova encontrada neste bloco.",
        },
        internalEvents: {
          show: "Eventos internos",
          hide: "Ocultar eventos internos",
          loading: "Carregando eventos internos...",
          empty: "Não há eventos internos para este atendimento.",
          systemAuthor: "Sistema",
          types: {
            message_received: "Mensagem recebida",
            message_sent: "Mensagem enviada",
            conversation_created: "Atendimento criado",
            conversation_reopened: "Atendimento reaberto",
            conversation_opened: "Atendimento aberto",
            ai_operational_failure: "Atendimento da IA interrompido por falha; revisão da equipe necessária",
            ai_operational_action_blocked: "Ação da IA não executada pelas regras do atendimento; o atendimento continua disponível.",
            ai_operational_pending: "Operação da IA requer revisão da equipe. Confira o atendimento e assuma o próximo passo antes de repetir uma ação.",
            ai_operational_close_resolved: "Atendimento encerrado por resolução validada.",
            ai_operational_close_inactivity: "Atendimento encerrado pelo prazo configurado de inatividade.",
            ai_operational_transfer: "Transferência validada e registrada.",
            ai_operational_reply: "Resposta da IA registrada; confirme o envio na conversa.",
            ai_operational_clarify: "Pergunta de esclarecimento registrada; confira a oferta e a resposta do contato.",
            ai_operational_no_reply: "IA decidiu não responder; isso não significa resolução.",
            ai_operational_clock_cancelled: "Espera automática do envio externo cancelada. O acompanhamento começa após atendimento efetivo da IA.",
            ai_operational_continuation_cancelled: "Continuidade anterior cancelada após mudança de contexto.",
            conversation_closed: "Atendimento fechado",
            conversation_status_changed: "Status alterado",
            assignment_changed: "Atendente alterado",
            queue_changed: "Fila alterada",
            ai_proactive_message_sent: "Mensagem ativa da IA",
            ai_proactive_attendance_closed: "Atendimento fechado pela IA",
            ai_skill_human_requested: "IA solicitou atendimento humano",
            ai_skill_attendance_closed: "IA fechou o atendimento",
            ai_skill_queue_transferred: "IA transferiu para fila",
            ai_skill_user_transferred: "IA transferiu para atendente",
            ai_skill_internal_note_added: "Nota interna da IA",
            internal_note_added: "Nota interna",
          },
        },
        mediaUnavailable: {
          default: "Mídia indisponível.",
          image: "Imagem indisponível.",
          audio: "Áudio indisponível.",
          video: "Vídeo indisponível.",
          document: "Documento indisponível.",
          sticker: "Figurinha indisponível.",
        },
        internalNote: {
          open: "Nota interna",
          title: "Adicionar nota interna",
          mentionsLabel: "Mencionar usuários",
          mentionsPlaceholder: "Selecione usuários para mencionar com @",
          noteLabel: "Nota interna",
          notePlaceholder: "Escreva uma nota interna. Usuários mencionados com @ serão adicionados como participantes do atendimento.",
          cancel: "Cancelar",
          save: "Salvar nota",
          saving: "Salvando...",
          toasts: {
            saved: "Nota interna salva.",
          },
        },
        header: {
          assignedTo: "Atribuído à:",
          buttons: {
            return: "Retornar",
            returnToPending: "Voltar para Aguardando",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Atender",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem ou tecle ''/'' para utilizar as respostas rápidas cadastrada",
        placeholderClosed:
          "Reabra ou aceite esse atendimento para enviar uma mensagem.",
        signMessage: "Assinar",
        internalNote: {
          toggle: "Mensagem interna",
          activeHint:
            "Modo nota interna ativo. Esta mensagem ficará visível apenas para a equipe e não será enviada ao contato.",
          placeholder:
            "Escreva uma nota interna. Use @Nome para mencionar e adicionar usuários como participantes.",
          mentionAll: "Todos",
          mentionAllHint: "Notificar todos os participantes e usuários disponíveis",
          mentionUserHint: "Usuário do Talk",
        },
        templateChooser: {
          title: "Escolha uma mensagem padrão",
          description:
            "Este contato está fora da janela de 24h do WhatsApp; para evitar spam, a Meta permite apenas o envio de mensagens padrão aprovadas, sendo permitido reenviar o mesmo modelo somente após 24 horas.",
          metaRules:
            "Regras da Meta (API Oficial): fora de 24 horas apenas templates aprovados são permitidos; evite repetir o mesmo template para o mesmo atendimento e priorize conteúdo contextual para reduzir bloqueios.",
          selectLabel: "Mensagem padrão",
          parameterLabel: "Valor para {{variable}}",
          parametersRequired: "Preencha todas as variáveis do template antes de enviar.",
          previewLabel: "Mensagem padrão",
          cancel: "Cancelar",
          send: "Enviar Mensagem",
          sending: "Enviando...",
        },
      },
      messageInput: {
        audio: {
          errors: {
            permissionDenied: "Permita o acesso ao microfone no navegador para gravar o áudio.",
            deviceNotFound: "Nenhum microfone foi encontrado neste dispositivo.",
            deviceUnavailable: "O microfone está ocupado ou indisponível. Feche outros aplicativos que possam estar usando-o e tente novamente.",
            notSupported: "Este navegador não oferece suporte à gravação de áudio. Atualize o navegador ou use outro dispositivo.",
            emptyAudio: "Nenhum áudio foi capturado. Grave novamente e aguarde um instante antes de enviar.",
            recordingFailed: "Não foi possível gravar o áudio. Verifique o microfone e tente novamente.",
          },
        },
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
        },
        extraInfo: "Outras informações",
      },
      ticketOptionsMenu: {
        copyLink: "Copiar link da atividade",
        copyLinkSuccess: "Link da atividade copiado.",
        delete: "Deletar",
        transfer: "Transferir",
        confirmationModal: {
          title: "Deletar o atendimento #",
          titleFrom: "do contato",
          message:
            "Atenção! Todas as mensagens relacionadas ao atendimento serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        resend: "Reenviar",
        resending: "Reenviando...",
        resendSuccess: "Mensagem reenviada. Aguarde a confirmação do WhatsApp.",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      backendErrors: {
        ERR_AI_OPERATIONAL_PROMPT_TOO_LONG: "As instruções e o contrato operacional ultrapassam o limite do Agents. Reduza o prompt editável preservando os dados importantes e tente novamente.",
        ERR_AI_OPERATIONAL_POLICY_INVALID: "Revise a política: selecione destinos válidos e informe prazos inteiros maiores que zero para as opções habilitadas.",
        ERR_AI_OPERATIONAL_POLICY_CONFLICT: "A configuração foi alterada por outra pessoa. Reabra o cadastro, confira a versão atual e salve novamente.",
        ERR_AI_OPERATIONAL_DESTINATION_INVALID: "Um destino selecionado não está disponível nesta empresa ou fila. Reabra o cadastro e revise a seleção.",
        ERR_AI_OPERATIONAL_SKILL_DISABLED: "Esta ferramenta não executa operações no novo modo. Transferência e fechamento dependem da decisão validada pelo Talk.",
        ERR_CONNECTION_OUTBOUND_QUEUE_INVALID: "Uma das filas autorizadas não pertence a esta organização.",
        ERR_NO_CONNECTION_FOUND: "A conexão correspondente não foi encontrada.",
        ERR_NETWORK_UNAVAILABLE:
          "A conexão com o servidor oscilou. Aguarde alguns instantes e tente novamente.",
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_OFFICIAL_SESSION_NOT_ALLOWED:
          "Esta ação de sessão está disponível apenas para conexões QR Code.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_CONTACT_INVALID_NUMBER:
          "Informe um telefone válido com DDI e DDD. Para números do Brasil, o +55 é incluído automaticamente.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_WAPP_EMPTY_PROVIDER_RESPONSE:
          "O WhatsApp Web não confirmou o envio da mensagem. Reinicie a conexão QR Code e tente novamente.",
        ERR_WAPP_MESSAGE_NOT_ACKNOWLEDGED:
          "O WhatsApp não confirmou a entrega desta mensagem. A conexão QR Code será verificada automaticamente.",
        ERR_MESSAGE_NOT_FOUND: "Mensagem não encontrada.",
        ERR_MESSAGE_RESEND_NOT_SUPPORTED:
          "O reenvio está disponível apenas para mensagens de texto em conexões WhatsApp QR Code.",
        ERR_MESSAGE_RESEND_MEDIA_NOT_SUPPORTED:
          "O reenvio de mídia ainda não está disponível. Envie o arquivo novamente.",
        ERR_MESSAGE_RESEND_NOT_ALLOWED:
          "Esta mensagem não pode ser reenviada. Ela já foi confirmada, apagada ou reenviada.",
        ERR_HISTORY_SYNC_NOT_SUPPORTED:
          "A busca de histórico anterior está disponível apenas para conexões WhatsApp QR Code.",
        ERR_HISTORY_SYNC_NO_WHATSAPP:
          "Não há uma conexão WhatsApp QR Code vinculada a este atendimento.",
        ERR_HISTORY_SYNC_FETCH_FAILED:
          "Não foi possível buscar o histórico no WhatsApp Web. Reinicie a conexão QR Code e tente novamente.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_OFFICIAL_PHONE_NOT_REGISTERED:
          "O número oficial configurado não está registrado na WhatsApp Business Platform Cloud API. Verifique o cadastro/registro do número na Meta.",
        ERR_OFFICIAL_MESSAGE_BLOCKED_BY_META:
          "A Meta bloqueou este envio para manter a qualidade de engajamento. Tente novamente mais tarde ou revise o conteúdo/template.",
        ERR_OFFICIAL_ACCESS_DENIED:
          "A Meta negou o envio por token ou permissão do número oficial. Reautorize a conexão ou confira as permissões na Meta.",
        ERR_META_TRANSIENT_SEND_ERROR:
          "A Meta retornou um erro temporário no envio. Tente novamente em alguns instantes.",
        ERR_OFFICIAL_TEMPLATE_REQUIRED_OUTSIDE_24H:
          "Sua mensagem não pode ser enviada como texto livre, pois está fora da janela de 24 horas. Envie um template aprovado da Meta para reabrir a conversa.",
        ERR_API_CONNECTION_REQUIRED:
          "Informe a conexão que deve ser usada nesta integração.",
        ERR_API_OFFICIAL_TEMPLATE_CONNECTION_REQUIRED:
          "O envio de template exige uma conexão de WhatsApp Oficial.",
        ERR_API_OPEN_TICKET_NOT_FOUND:
          "Nenhum atendimento aberto foi encontrado para este número.",
        ERR_API_RESOLVE_INVALID_NUMBER:
          "Informe um número válido para finalizar o atendimento.",
        ERR_API_TICKET_ALREADY_CLOSED:
          "Este atendimento já estáva fechado.",
        ERR_TICKET_ALREADY_CLOSED:
          "Este atendimento já estáva fechado.",
        ERR_API_RESOLVE_METHOD_NOT_ALLOWED:
          "Use POST para finalizar um atendimento pela API.",
        ERR_OFFICIAL_TEMPLATE_NOT_ALLOWED_FOR_QUEUE:
          "O template informado não está permitido para a fila deste atendimento.",
        ERR_OFFICIAL_TEMPLATE_ALREADY_SENT:
          "Este mesmo template já foi enviado neste atendimento. Escolha outro template aprovado.",
        ERR_META_TEMPLATE_PARAMETER_FORMAT_INVALID: "Escolha um formato válido para as variáveis do template.",
        ERR_META_TEMPLATE_PARAMETER_FORMAT_MIXED: "Não misture variáveis por nome e por posição no mesmo template.",
        ERR_META_TEMPLATE_PARAMETER_NAME_INVALID: "Use nomes de variável em minúsculas, sem espaços ou acentos, como nome_cliente.",
        ERR_META_TEMPLATE_POSITIONAL_SEQUENCE_INVALID: "As variáveis posicionais devem começar na posição 1 e seguir sem pular números.",
        ERR_META_TEMPLATE_PARAMETER_FORMAT_MISMATCH: "As variáveis do texto não correspondem ao formato selecionado.",
        ERR_META_TEMPLATE_PARAMETER_FORMAT_WITHOUT_VARIABLES: "Remova o formato de variáveis ou inclua ao menos uma variável no texto.",
        ERR_META_TEMPLATE_PARAMETER_EXAMPLE_REQUIRED: "Informe um exemplo para cada variável do template.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um atendimento aberto para este contato.",
        ERR_OTHER_OPEN_TICKET_WITH_USER_QUEUE:
          "Já existe um atendimento {{ticket}} aberto para este contato com {{user}}, na fila {{queue}}. Peça para esse usuário transferir o atendimento para você.",
        ERR_OTHER_OPEN_TICKET_WITH_USER:
          "Já existe um atendimento {{ticket}} aberto para este contato com {{user}}. Peça para esse usuário transferir o atendimento para você.",
        ERR_OTHER_OPEN_TICKET_WITH_QUEUE:
          "Já existe um atendimento {{ticket}} aberto para este contato na fila {{queue}}, aguardando atendimento.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_ACCESS_SCHEDULE_OUTSIDE_HOURS:
          "Seu horário de acesso permitido terminou. Fale com um administrador se precisar de liberação temporária.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_TRANSFER_QUEUE_NOT_ALLOWED: "Você só pode transferir atendimentos dentro das filas às quais pertence.",
        ERR_TRANSFER_USER_NOT_IN_QUEUE: "O atendente selecionado não pertence à fila de destino.",
        ERR_AI_AGENT_NOT_READY: "O agente de IA selecionado ainda não está ativo e pronto para atender.",
        ERR_AI_AGENT_TEMPLATE_NOT_FOUND: "O modelo de agente selecionado não existe mais. Escolha outro modelo.",
        ERR_AI_AGENT_INTELLIGENCE_PROFILE: "Escolha um nível de inteligência válido.",
        ERR_AI_AGENT_COMMUNICATION_PROFILE: "Escolha opções válidas de tom e tamanho de resposta.",
        ERR_AI_AGENT_AUTONOMY_PROFILE: "Escolha um nível de autonomia válido.",
        ERR_AI_AGENT_CAPABILITY_NOT_FOUND: "Uma das capacidades selecionadas não pertence a este modelo.",
        ERR_AI_AGENT_CAPABILITY_REQUIRED: "Habilite ao menos uma capacidade antes de publicar.",
        ERR_AI_AGENT_ORGANIZATION_REQUIRED: "Informe o nome da empresa ou unidade antes de publicar.",
        ERR_AI_AGENT_SIMULATION_MESSAGE_REQUIRED: "Digite uma mensagem de teste entre 2 e 1.500 caracteres.",
        ERR_AI_AGENT_SIMULATION_NOT_READY: "Salve um rascunho completo do agente antes de usar o simulador.",
        ERR_AI_AGENT_SIMULATION_EMPTY_RESPONSE: "O simulador não recebeu uma resposta válida. Tente novamente em instantes.",
        ERR_AI_DISSATISFACTION_QUEUE_REQUIRED: "Selecione a fila responsável antes de ativar o escalonamento de contatos insatisfeitos.",
        ERR_AI_DISSATISFACTION_QUEUE_INVALID: "A fila responsável selecionada não está disponível nesta empresa.",
        ERR_AI_INTERNAL_SKILLS_INVALID: "Selecione somente ferramentas operacionais válidas para o agente.",
        ERR_REQUEST_BODY_TOO_LARGE: "Os dados enviados são muito extensos. Reduza o conteúdo dos campos longos ou envie arquivos pelo campo de anexo.",
        ERR_COMPANY_NOT_FOUND: "Organização não encontrada.",
        ERR_ORGANIZATION_LOGO_INVALID: "Use um logotipo PNG, JPG ou WebP de até 2 MB.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum atendimento encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_WHATSAPP_COEXISTENCE_DISABLED: "Novas conexões em coexistência estão temporariamente desativadas neste ambiente.",
        ERR_WHATSAPP_COEXISTENCE_CONFIG_REQUIRED: "A configuração de Embedded Signup para coexistência ainda não foi concluída na Meta.",
        ERR_WHATSAPP_COEXISTENCE_NOT_ACTIVE: "A Meta não confirmou a coexistência deste número. Confirme que ele continua ativo no aplicativo WhatsApp Business e conclua o fluxo específico de coexistência.",
        ERR_META_APPLICATION_NOT_FOUND: "O aplicativo Meta não existe ou não pertence à sua empresa.",
        ERR_META_APPLICATION_INACTIVE: "O aplicativo Meta selecionado está inativo.",
        ERR_META_APPLICATION_IN_USE: "Este aplicativo Meta está vinculado a uma conexão e não pode ser excluído.",
        ERR_META_APPLICATION_REQUIRED_FIELDS: "Informe nome, App ID e App Secret.",
        ERR_META_OAUTH_STATE_INVALID: "A autorização da Meta expirou ou não pertence a esta conexão. Inicie o processo novamente.",
        ERR_META_OAUTH_STATE_SECRET_NOT_CONFIGURED: "A assinatura segura do login Meta não está configurada no servidor.",
        ERR_USER_REQUIRED: "É obrigatório informar um atendente.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar atendimento no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_QUEUE_MANUAL_ATTENDANCE_DISABLED:
          "Esta fila não permite atendimento manual. Transfira o atendimento para outra fila para aceitar.",
        ERR_QUEUE_AI_AGENTS_DISABLED:
          "Esta fila não permite agentes de IA. Ative a permissão da fila antes de atribuir este atendimento.",
        ERR_FLOWCH_AGENTS_API_KEY_NOT_CONFIGURED:
          "A chave da API do Flowch Agents não está configurada no backend.",
        ERR_FLOWCH_AGENTS_API_REQUEST_FAILED:
          "A API do Flowch Agents retornou erro. Confira a configuração e tente novamente.",
        ERR_FLOWCH_AGENTS_TENANT_MISMATCH:
          "Esta chave pertence a outro tenant do Flowch Agents e não contém os agentes vinculados a esta empresa. Use uma chave rotacionada do mesmo tenant ou desvincule os agentes antes de migrar.",
        ERR_FLOWCH_AGENTS_API_INVALID_RESPONSE:
          "A API do Flowch Agents retornou uma resposta inválida.",
        ERR_AI_SKILL_SIGNATURE_REQUIRED:
          "A chamada da skill interna precisa de assinatura.",
        ERR_AI_SKILL_NAMESPACE_INVALID: "O namespace das ferramentas deve começar com letra minúscula e conter até 32 letras minúsculas, números ou sublinhados.",
        ERR_AI_SKILL_INVALID_SIGNATURE:
          "A assinatura da skill interna é inválida.",
        ERR_AI_SKILL_NOT_SUPPORTED:
          "Esta skill interna não é suportada pelo Talk.",
        ERR_AI_FAILURE_POLICY_INVALID: "Revise a configuração de contingência: selecione uma fila válida quando habilitar a transferência.",
        ERR_AI_FAILURE_OPERATIONAL_REQUIRED: "A transferência por falha exige o modo operacional do agente.",
        ERR_AI_FAILURE_QUEUE_INVALID: "A fila de contingência deve pertencer à sua empresa, permitir atendimento manual e não atribuir automaticamente à IA.",
        ERR_AI_INTERNAL_SKILL_DISABLED:
          "Esta ferramenta operacional está desativada para o agente responsável pelo atendimento.",
        ERR_AI_SKILL_TICKET_REQUIRED:
          "Informe o atendimento para executar a skill interna.",
        ERR_AI_SKILL_TICKET_NOT_ASSIGNED_TO_AI:
          "Este atendimento não está atribuído a um agente de IA.",
        ERR_AI_SKILL_NOTE_REQUIRED:
          "Informe a nota interna que deve ser registrada.",
        ERR_INTERNAL_NOTE_REQUIRED:
          "Informe a nota interna que deve ser registrada.",
        ERR_TICKET_PARTICIPANT_NOT_FOUND:
          "Participante do atendimento não encontrado.",
        ERR_AI_SKILL_CONTACT_FIELDS_REQUIRED:
          "Informe ao menos um campo do contato para atualizar.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
      },
    },
  },
};

export { messages };
